import { Link } from 'types/layout';
import { NavigationLink } from 'types/header';

export const marketingLinks: Array<NavigationLink> = [
	{
		text: 'how it works',
		router: 'how-it-works'
	},
	{
		text: 'investments',
		router: 'investments'
	},
	{
		dropdown: 'strategy',
		links: [
			{
				text: 'overview',
				router: 'strategy'
			},
			{
				text: 'why real estate',
				router: 'why-private-real-estate'
			},
			{
				text: 'real estate strategies',
				router: 'real-estate-strategies'
			},
			{
				text: 'track record',
				router: 'track-record'
			}
		]
	},
	{
		dropdown: 'resources',
		links: [
			{
				text: 'help & faqs',
				href: '/help'
			},
			{
				text: 'education',
				router: 'blog-landing'
			}
		]
	}
];

export const marketingLinksAbTestTrackRecord: Array<NavigationLink> = [
	{
		text: 'how it works',
		router: 'how-it-works'
	},
	{
		text: 'track record',
		router: 'track-record'
	},
	{
		text: 'investments',
		router: 'investments'
	},
	{
		dropdown: 'strategy',
		links: [
			{
				text: 'overview',
				router: 'strategy'
			},
			{
				text: 'why real estate',
				router: 'why-private-real-estate'
			},
			{
				text: 'real estate strategies',
				router: 'real-estate-strategies'
			}
		]
	},
	{
		dropdown: 'resources',
		links: [
			{
				text: 'help & faqs',
				href: '/help'
			},
			{
				text: 'education',
				router: 'blog-landing'
			}
		]
	}
];

export const settingsLinks: Array<Link> = [
	{
		text: 'Settings',
		href: '/account/investment-accounts/personal-information'
	},
	{
		text: 'Log Out',
		href: '/logout'
	}
];
